export enum AddDestinationsModalSteps {
    SelectDestination = "select-destination",
    PlatformSettings = "platform-settings",
    Processing = "processing"
}

// Simpler than NewLivestreamModal's SubmissionStatus - no "hard failure" case here.
export enum AddDestinationsSubmissionStatus {
    Processing = "processing",
    Success = "success",
    Mixed = "mixed"
}
